import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  conigMenu: [],
};

const sideMenuSlice = createSlice({
  name: 'sideMenuSlice',
  initialState,
  reducers: {
    setConigMenu: (state: any, action: PayloadAction<any>) => {
      state.conigMenu = action.payload;
    },
    removeConigMenu: (state: any) => {
      state.conigMenu = [];
    },
  },
});

export const { setConigMenu, removeConigMenu } = sideMenuSlice.actions;

export default sideMenuSlice.reducer;
